import Version from './lib/Version';

class App {
  /**
   * @param {Object} config
   * @param {string} config.appVersion
   * @param {string} config.databaseVersion
   * @param {string} config.tessituraVersion
   * @param {string} config.environment
   * @param {string} config.rootUrl
   * @param {boolean} config.isVersionSevenEnabled
   * @param {string} config.bcp47LanguageTag
   * @param {string} config.iso4217CurrencyCode
   */
  init({
    appVersion,
    databaseVersion,
    tessituraVersion,
    environment,
    rootUrl,
    isVersionSevenEnabled,
    bcp47LanguageTag,
    iso4217CurrencyCode,
  }) {
    this.appVersion = Version.fromString(appVersion);
    this.databaseVersion = Version.fromString(databaseVersion);
    this.tessituraVersion = Version.fromString(tessituraVersion);
    this.environment = environment;
    this.rootUrl = rootUrl;
    this.isVersionSevenEnabled = isVersionSevenEnabled;
    this.bcp47LanguageTag = bcp47LanguageTag;
    this.iso4217CurrencyCode = iso4217CurrencyCode;
  }

  getRootUrl() {
    return this.rootUrl;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/tnew/App.js